<template>
  <div class="task">
      <v-progress-circular v-if="this.saving"
        indeterminate
        color="green"
      ></v-progress-circular>

  <v-row>
    <v-col cols="12" sm="12" > 
      <v-card>
        <v-row align="center" class="list px-3 mx-auto">
          <v-col cols="12" sm="4">
            <v-text-field
              v-model="searchName"
              :label="langC.Search"
              append-icon="mdi-magnify"
              clearable
              hide-details
              @keyup.enter="doSearch"
              @click:append="doSearch"
              @click:clear="clearSearch"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="1">
            <v-btn small @click="doSearch">
              {{langC.Search}}
            </v-btn>
          </v-col>
          <v-col cols="5" sm="4">
            <v-pagination
              v-model="page"
              :length="totalPages"
              total-visible="7"
              next-icon="mdi-menu-right"
              prev-icon="mdi-menu-left"
              @input="handlePageChange"
            ></v-pagination>
            
          </v-col>
          <v-col cols="4" sm="1" >
            Total:{{totalItems}}
          </v-col>
          <v-col cols="4" sm="1" >
            <v-select
              v-model="pageSize"
              :items="pageSizes"
              :label="langC.ItemsPerPage"
              @change="handlePageSizeChange"
            ></v-select>
        </v-col>
      </v-row>
     </v-card>
    </v-col>
  </v-row> 

  <v-row>
    <v-col cols="12" sm="12"> 
      <v-card>
        <v-card-title>
          {{ documentNameLoc }}
          <v-spacer></v-spacer>
          <v-text-field
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            v-model="search"
          ></v-text-field>
        </v-card-title>
        <v-data-table
            dense
            :headers="headers"
            :items="items"
            item-key="documentId"
            :search="search"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, 50]
            }"
            :items-per-page="50"
            @click:row="navigateTo"
            :mobile-breakpoint="0" 
          >

          <template v-slot:[`item.BookID`]="{ item }">
              <span>{{ parseInt(item.BookID) }}</span>
          </template>
          <template v-slot:[`item.ClosedAccount`]="{ item }">
            <span v-if="item.ClosedAccount"><v-icon>mdi-check</v-icon></span>
          </template>
          <template v-slot:[`item.InvoiceAmount`]="{ item }">
             <h3><span>{{ localMoney(item.InvoiceAmount) }}</span></h3>
          </template>
          <template v-slot:[`item.InvoiceForeginAmount`]="{ item }">
              <span>{{ localMoney(item.InvoiceForeginAmount) }}</span>
          </template>

          <template v-slot:[`item.BookingDate`]="{ item }">
              <span>{{ localDate(item.BookingDate) }}</span>
          </template>
          <template v-slot:[`item.InvoiceDate`]="{ item }">
              <span>{{ localDate(item.InvoiceDate) }}</span>
          </template>
          <template v-slot:[`item.MLFree2`]="{ item }">
            <span v-if="item.MLFree2"><v-icon>mdi-check</v-icon></span>
          </template>
          <template v-slot:[`item.paidClosed`]="{ item }">
            <v-chip v-if="item.paidClosed" color="green" dark small>{{ oznakaPlacanja(item) }}</v-chip>
          </template>
          <template v-slot:[`item.virmanId`]="{ item }">
            <v-icon v-if="item.virmanId" color="green" title="Virman je napravljen">mdi-check</v-icon>
          </template>
          <template v-slot:[`item.paymentApproved`]="{ item }">
            <v-icon
              :color="bojaOdobrenja(item)"
              :title="naslovOdobrenja(item)"
              @click.stop="prebaciOdobrenje(item)"
            >{{ ikonaOdobrenja(item) }}</v-icon>
          </template>
          <template v-slot:[`item.danaKasnjenja`]="{ item }">
            <span v-if="item.danaKasnjenja > 0" class="red--text font-weight-bold">{{ item.danaKasnjenja }}</span>
          </template>
          <template slot="pageText" slot-scope="{ pageStart, pageStop }">
            From {{ pageStart }} to {{ pageStop }}
          </template>
        </v-data-table>
      </v-card>
     </v-col>
    </v-row> 

    <v-dialog v-model="odobrenjeDialog" max-width="460px">
      <v-card v-if="odobrenjeItem">
        <v-card-title class="title">
          <v-icon :color="odobrenjeNovo ? 'green' : 'orange'" class="mr-2">
            {{ odobrenjeNovo ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline' }}
          </v-icon>
          {{ odobrenjeNovo ? 'Odobrenje plaćanja' : 'Povlačenje odobrenja' }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <v-row no-gutters class="mb-1">
            <v-col cols="4" class="grey--text text--darken-1">Partner</v-col>
            <v-col cols="8" class="font-weight-medium">{{ odobrenjeItem.partnerName }}</v-col>
          </v-row>
          <v-row no-gutters class="mb-1">
            <v-col cols="4" class="grey--text text--darken-1">Račun</v-col>
            <v-col cols="8">{{ odobrenjeItem.InvoiceNumber }}</v-col>
          </v-row>
          <v-row no-gutters class="mb-1">
            <v-col cols="4" class="grey--text text--darken-1">Iznos</v-col>
            <v-col cols="8" class="font-weight-bold">{{ localMoney(odobrenjeItem.InvoiceAmount) }}</v-col>
          </v-row>
          <v-row no-gutters class="mb-1">
            <v-col cols="4" class="grey--text text--darken-1">Dospijeće</v-col>
            <v-col cols="8">
              {{ localDate(odobrenjeItem.InvoicePaymentDeadlineDate) }}
              <span v-if="odobrenjeItem.danaKasnjenja > 0" class="red--text font-weight-bold ml-2">
                kasni {{ odobrenjeItem.danaKasnjenja }} {{ odobrenjeItem.danaKasnjenja === 1 ? 'dan' : 'dana' }}
              </span>
            </v-col>
          </v-row>
          <v-row no-gutters v-if="!odobrenjeNovo && odobrenjeItem.paymentApprovedBy" class="mt-3">
            <v-col cols="12" class="grey--text text--darken-1">
              Odobrio {{ odobrenjeItem.paymentApprovedBy }}, {{ localDate(odobrenjeItem.paymentApprovedDate) }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="odobrenjeDialog = false" :disabled="odobrenjeSaving">{{langC.Cancel}}</v-btn>
          <v-btn
            :color="odobrenjeNovo ? 'green' : 'orange'"
            dark
            :loading="odobrenjeSaving"
            @click="potvrdiOdobrenje"
          >{{ odobrenjeNovo ? 'Odobri' : 'Povuci' }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :timeout="timeout" bottom :color="color">
      {{ text }}
    </v-snackbar>
  </div>
</template>

<script>
// import axios from 'axios'
import MainLedgerService from '@/services/MainLedgerService'
import MainLedgerDetailService from '@/services/MainLedgerDetailService'
import {checkBooks } from './mainledgerHelper'
import { mapGetters } from 'vuex'
import ledgerEN from './MainLedgerDescEN'
import ledgerHR from './MainLedgerDescHR'
import commEn from "@/language/commonEN"
import commHr from "@/language/commonHR"
import dateFormat from '@/snippets/dateFormat'
import moneyFormat from '@/snippets/moneyFormat'
import dayjs from 'dayjs'
import {nacinIzSifre} from './nacinPlacanja'

export default {
  name: 'MainLedgerlist',
  data () {
    return {
      documentName: '',
      documentNameLoc: '',
      docside: 0,
      msg: '',
      items: [],
      max25chars: (v) => v.length <= 25 || 'Input too long!',
      tmp: '',
      search: '',
      pagination: {},
      rowsPerPageItems: [50],
      headers: [ ],
      mainQuery: {
        CompanyId: 1,
        businessYear: 0,
        MLType: 1
      },
      columns: [],
      rows: [],
      lang: {},
      langC: {},
      saving: false,
      searchName: "",
      page: 1,
      totalPages: 0,
      pageSize: 30,
      pageSizes: [10, 30, 50],

      totalItems: 0,
      bookTypeSelected: {},
      samPostavioKnjigu: false,
      show: 0,
      paid: '',
      odobrenjeDialog: false,
      odobrenjeItem: null,
      odobrenjeNovo: false,
      odobrenjeSaving: false,
      snackbar: false,
      text: '',
      color: 'green',
      timeout: 4000
    }
  },
  async mounted () {
    if (this.$store.state.language === "EN") {
        this.lang = ledgerEN
        this.langC = commEn;
      }
      if (this.$store.state.language === "HR") {
        this.lang = ledgerHR
        this.langC = commHr;
      }
    this.defaultInit()
  },
  methods: {
     localMoney(moneyToFormat) {
      return moneyFormat(moneyToFormat)
    },
    async defaultInit() {
      this.$store.dispatch('seteditItem', 0)
      this.headers = []
      this.paid = this.lang.PaidClosed
     
      if (!this.$store.state.bookTypeSelected) {
        await this.$store.dispatch('setbookTypeSelected', null)
        this.show = this.$store.state.documentSide ? this.$store.state.documentSide : 1
        // checkBooks upise vrstu knjige u store, a bas tu vrijednost pratimo u
        // watchu 'myBookSelected' - pa se popis ucitavao drugi put, s potpuno
        // istim upitom. Oznaka se postavlja PRIJE poziva jer watch stigne na
        // red prije nego se nastavi izvodjenje iza "await", pa bi je postavljanje
        // poslije zakasnilo. Cisti se u nextTick-u: ako checkBooks nije nista
        // promijenio, watch se nije ni okinuo i oznaka ne smije ostati podignuta
        // i progutati sljedecu, korisnikovu promjenu.
        this.samPostavioKnjigu = true
        await checkBooks(this.show)
        this.$nextTick(() => { this.samPostavioKnjigu = false })
      }
      const query = this.setQuery()
      if (query.searchName) {
        this.searchName = query.searchName
      }
      this.saving = true

      await MainLedgerService.indexlist(query)
      .then(res => {
        const dosli = res.data.documents ? res.data.documents : []
        this.items = dosli.map(item => ({...item, danaKasnjenja: this.danaKasnjenja(item)}))
        this.totalItems = res.data.totalPages
        this.totalPages = parseInt(res.data.totalPages / this.pageSize) + 1
      })
      .catch(err => {
        this.havealert = !this.havealert
        this.havemssgalert = 'Error' + err
      })
      this.saving = false
      this.documentName = this.$store.state.documentActiv
      this.documentNameLoc = this.$store.state.documentActivLoc
      if (this.$store.state.documentSide === 1) {
        this.headers.push(
          {
            text: this.lang.BookID, align: 'left', sortable: true, value: 'BookID', width: '60px'
          },
          { text: this.lang.ClosedAccount, align: 'left', sortable: true, value: 'ClosedAccount', width: '50px' },
          { text: this.lang.BookTypeID, align: 'left', sortable: true, value: 'BookName', width: '50px' },
          { text: this.lang.BookingDate, align: 'left', sortable: true, value: 'BookingDate', width: '80px' },
          { text: this.lang.InvoiceNumber, align: 'center', value: 'InvoiceNumber', width: '100px' },
          { text: this.lang.InvoiceDate, align: 'left', sortable: true, value: 'InvoiceDate', width: '80px' },
          { text: this.lang.InvoiceAmount, align: 'right', sortable: true, value: 'InvoiceAmount', width: '100px' },
          { text: this.lang.HomeCurrency, align: 'left', sortable: true, value: 'HomeCurrency', width: '40px' },
          { text: this.lang.PartnerName, align: 'left', value: 'partnerName', width: '260px' },
          { text: this.lang.PartnerVATID, align: 'left', value: 'partnerVATID', width: '80px' },
          { text: this.lang.ConnName, align: 'left', value: 'ConnName', width: '80px' },
          { text: this.lang.ConnId, align: 'left', value: 'ConnId', width: '80px' },
          { text: this.lang.Virman, align: 'center', value: 'virmanId', width: '60px' },
          { text: this.lang.PaymentApproved, align: 'center', value: 'paymentApproved', width: '70px' },
          { text: this.lang.PaidClosed, align: 'left', value: 'paidClosed', width: '80px' },
          { text: this.lang.DaysLate, align: 'right', sortable: true, value: 'danaKasnjenja', width: '50px' },
          { text: this.lang.MLFree2, align: 'left', value: 'MLFree2', width: '80px' },
          // Devizni iznos i valuta idu na kraj: vecina racuna je u domacoj
          // valuti pa su ta dva stupca najcesce prazna, a dotad su razdvajala
          // iznos od partnera. "DbId" ostaje posljednji, kao i drugdje.
          { text: this.lang.InvoiceForeginAmount, align: 'right', sortable: true, value: 'InvoiceForeginAmount', width: '100px' },
          { text: this.lang.ForeignCurrency, align: 'left', sortable: true, value: 'ForeignCurrency', width: '40px' },
          { text: 'DbId', value: 'id', width: '60px' }
        )
      }
      if (this.$store.state.documentSide === 2) {
        this.headers.push(
          {
            text: this.lang.BookID2, align: 'left', sortable: true, value: 'BookID', width: '60px'
          },
          { text: this.lang.ClosedAccount, align: 'left', sortable: true, value: 'ClosedAccount', width: '50px' },
          { text: this.lang.BookTypeID, align: 'left', sortable: true, value: 'BookName', width: '50px' },
          { text: this.lang.BookingDate, align: 'left', sortable: true, value: 'BookingDate', width: '80px' },
          { text: this.lang.InvoiceDate, align: 'left', sortable: true, value: 'InvoiceDate', width: '80px' },
          { text: this.lang.InvoiceAmount, align: 'right', sortable: true, value: 'InvoiceAmount', width: '100px' },
          { text: this.lang.HomeCurrency, align: 'left', sortable: true, value: 'HomeCurrency', width: '40px' },
          { text: this.lang.PartnerName, align: 'left', value: 'partnerName', width: '260px' },
          { text: this.lang.PartnerVATID, align: 'left', value: 'partnerVATID', width: '80px' },
          { text: this.lang.ConnName, align: 'left', value: 'ConnName', width: '80px' },
          { text: this.lang.ConnId, align: 'left', value: 'ConnId', width: '80px' },
          { text: this.lang.PaidClosed, align: 'left', value: 'paidClosed', width: '80px' },
          { text: this.lang.DaysLate, align: 'right', sortable: true, value: 'danaKasnjenja', width: '50px' },
          { text: this.lang.MLFree2, align: 'left', value: 'MLFree2', width: '80px' },
          // Devizni iznos i valuta idu na kraj: vecina racuna je u domacoj
          // valuti pa su ta dva stupca najcesce prazna, a dotad su razdvajala
          // iznos od partnera. "DbId" ostaje posljednji, kao i drugdje.
          { text: this.lang.InvoiceForeginAmount, align: 'right', sortable: true, value: 'InvoiceForeginAmount', width: '100px' },
          { text: this.lang.ForeignCurrency, align: 'left', sortable: true, value: 'ForeignCurrency', width: '40px' },
          { text: 'DbId', value: 'id', width: '60px' }
        )
      }
      if (this.$store.state.documentSide === 3 || this.$store.state.documentSide === 4) {
        this.headers.push(
          {
            text: this.lang.BookID, align: 'left', sortable: true, value: 'BookID'
          },
          { text: this.lang.ClosedAccount, align: 'left', sortable: true, value: 'ClosedAccount' },
          { text: this.lang.BookTypeID, align: 'left', sortable: true, value: 'BookName' },
          { text: this.lang.BookingName, align: 'left', sortable: true, value: 'BookName' },
          { text: this.lang.BookingDate, align: 'left', sortable: true, value: 'BookingDate' },
          { text: this.lang.InvoiceNumber, align: 'center', value: 'InvoiceNumber' },
          { text: this.lang.MLFree1, align: 'left', sortable: true, value: 'MLFree1' },
          { text: this.lang.DebitTotal, align: 'left', sortable: true, value: 'DebitTotal' },
          { text: this.lang.CreditTotal, align: 'left', sortable: true, value: 'CreditTotal' },
          { text: 'DbId', value: 'id' }
        )
      }
    },
    async navigateTo (params) {
      await this.$store.dispatch('setMainLedgerTotals', 0)
      await this.$store.dispatch('seteditItem', 0)
      this.$store.dispatch('setretPath', 'mainledger')
      await this.$store.dispatch('setMainLedgerid', params.id)
      const locDocument = await MainLedgerService.show(params.id)
      this.mainledger = locDocument.data.mainLedger
      this.mldetails = (await MainLedgerDetailService.index(params.id)).data.mainledgerDetails
      await this.$store.dispatch('setMainLedgerActiv', this.mainledger ? this.mainledger : {})
      await this.$store.dispatch('setMainLedgerItems', this.mldetails ? this.mldetails : [])
      this.bookTypeSelected.text = this.mainledger.BookName
      this.bookTypeSelected.value = parseInt(this.mainledger.BookTypeID)
      await this.$store.dispatch('setbookTypeSelected', this.bookTypeSelected)
      this.$router.push({
        name: 'mainledgerview'
      })
    },
    localDate(dateToFormat) {
       return dateFormat(dateToFormat)
    },
    // Koliko dana racun kasni. Racuna se samo dok nije oznacen kao placen.
    danaKasnjenja (item) {
      if (!item || item.paidClosed) { return 0 }
      if (!item.InvoicePaymentDeadlineDate) { return 0 }
      const dospijece = dayjs(item.InvoicePaymentDeadlineDate).startOf('day')
      if (!dospijece.isValid()) { return 0 }
      const dana = dayjs().startOf('day').diff(dospijece, 'day')
      return dana > 0 ? dana : 0
    },
    naslovOdobrenja (item) {
      if (item.paidClosed && !item.paymentApproved) { return 'Račun je plaćen, odobrenje nije potrebno' }
      if (!item.paymentApproved) { return 'Odobri plaćanje' }
      const tko = item.paymentApprovedBy ? item.paymentApprovedBy : ''
      const kada = item.paymentApprovedDate ? dateFormat(item.paymentApprovedDate) : ''
      return ('Odobrio ' + tko + ' ' + kada).trim()
    },
    // Placen racun uz gotovinu/karticu nosi i cime je placen.
    oznakaPlacanja (item) {
      const nacin = nacinIzSifre(item.PaymentMeansCode)
      return nacin.placeno ? this.paid + ' - ' + nacin.naziv.toLowerCase() : this.paid
    },
    ikonaOdobrenja (item) {
      if (item.paymentApproved) { return 'mdi-check-circle' }
      if (item.paidClosed) { return 'mdi-minus-circle-outline' }
      return 'mdi-checkbox-blank-circle-outline'
    },
    bojaOdobrenja (item) {
      if (item.paymentApproved) { return 'green' }
      return 'grey lighten-1'
    },
    javi (poruka, boja) {
      this.text = poruka
      this.color = boja
      this.timeout = boja === 'green' ? 3000 : 5000
      this.snackbar = true
    },
    // Klik otvara potvrdu; placen racun se ne odobrava.
    prebaciOdobrenje (item) {
      if (!item.paymentApproved && item.paidClosed) {
        this.javi('Račun je već plaćen, odobrenje plaćanja nije potrebno.', 'blue')
        return
      }
      this.odobrenjeItem = item
      this.odobrenjeNovo = !item.paymentApproved
      this.odobrenjeDialog = true
    },
    async potvrdiOdobrenje () {
      const item = this.odobrenjeItem
      if (!item) { return }
      const novo = this.odobrenjeNovo
      const email = this.$store.state.user && this.$store.state.user.email ? this.$store.state.user.email : ''
      this.odobrenjeSaving = true
      try {
        const {data} = await MainLedgerService.odobriplacanje(item.id, novo, email)
        const snimljeno = data && data.newDoc ? data.newDoc : null
        item.paymentApproved = snimljeno ? snimljeno.paymentApproved : novo
        item.paymentApprovedBy = snimljeno ? snimljeno.paymentApprovedBy : email
        item.paymentApprovedDate = snimljeno ? snimljeno.paymentApprovedDate : new Date()
        item.danaKasnjenja = this.danaKasnjenja(item)
        this.odobrenjeDialog = false
        this.javi(novo ? 'Plaćanje je odobreno.' : 'Odobrenje je povučeno.', 'green')
      } catch (err) {
        // Bez poruke se ne vidi je li pao server, mreza ili sam upis.
        const odgovor = err && err.response ? err.response : null
        if (odgovor && odgovor.status === 409) {
          item.paidClosed = true
          this.odobrenjeDialog = false
          this.javi(odgovor.data && odgovor.data.message ? odgovor.data.message : 'Račun je plaćen, odobrenje nije moguće', 'blue')
        } else {
          const detalj = odgovor
            ? ('server je vratio ' + odgovor.status)
            : 'server nije dostupan (provjerite radi li backend)'
          this.javi('Odobrenje nije spremljeno - ' + detalj, 'red')
        }
      }
      this.odobrenjeSaving = false
    },
    // handlePageChange(value) {
    //   this.page = value;
    //   this.defaultInit();
    // },
    // handlePageSizeChange(size) {
    //   this.pageSize = size;
    //   this.page = 1;
    //   this.defaultInit();
    // },
    // handleSearchOption(option) {
    //   this.searchOption = option
    // },
    // setQuery() {
    //   const query = {}
    //   if (this.$store.state.companyid) {
    //     query.CompanyId = this.$store.state.companyid
    //   }
    //   if (this.$store.state.businessYear) {
    //     query.BusinessYear = this.$store.state.businessYear
    //   }
    //   if (this.$store.state.documentActiv) {
    //     query.documentName = this.$store.state.documentActiv
    //   }
    //   if (this.$store.state.documentSide) {
    //     this.docSide = this.$store.state.documentSide
    //     query.MLType = this.$store.state.documentSide
    //   }
    //   // if (this.$store.state.bookTypeSelected) {
    //   //   query.BookTypeID = this.$store.state.bookTypeSelected.value
    //   // }
    //   query.searchName = this.searchName ? this.searchName.trim() : null
    //   query.page = this.page ? this.page - 1 : 0
    //   query.pageSize = this.pageSize ? this.pageSize : 30
    //   query.searchItem = this.searchOption ? this.searchOption : null
    //   return query
    // },
    async handlePageChange(value) {      
      const query = this.$store.state.onPage
      query.page = value - 1;
      this.page = value
      await this.$store.dispatch('setOnPage', query)
      this.defaultInit();
    },

    async handlePageSizeChange(size) {
      const query = this.$store.state.onPage
      query.pageSize = size;
      query.page = 1;
      this.pageSize = size
      await this.$store.dispatch('setOnPage', query)
      this.defaultInit();
    },

    async doSearch() {
      const query = this.$store.state.onPage
      query.searchName = this.searchName ? this.searchName.trim() : null
      query.searchItem = null
      query.page = 0
      this.page = 1
      await this.$store.dispatch('setOnPage', query)
      this.defaultInit()
    },

    async clearSearch() {
      this.searchName = ''
      await this.doSearch()
    },

    setQuery() {
      const haveOnPage = this.$store.state.onPage
      const query = {}
      if (this.$store.state.companyid) {
        query.CompanyId = this.$store.state.companyid
      }
      if (this.$store.state.businessYear) {
        query.BusinessYear = this.$store.state.businessYear
      }
      if (this.$store.state.documentActiv) {
        query.documentName = this.$store.state.documentActiv
      }
      if (this.$store.state.bookTypeSelected) {
        query.BookTypeID = this.$store.state.bookTypeSelected.value ? this.$store.state.bookTypeSelected.value : ''
      }
      query.searchName = haveOnPage.searchName ? haveOnPage.searchName.trim() : null
      query.page = haveOnPage.page ? haveOnPage.page : 0
      this.page  = query.page + 1
      query.pageSize = haveOnPage.pageSize ? haveOnPage.pageSize : 30
      this.pageSize = query.pageSize
      query.searchItem = null
      return query
    },
    async defaultQuery() {
      const query = {}
      if (this.$store.state.companyid) {
        query.CompanyId = this.$store.state.companyid
      }
      if (this.$store.state.businessYear) {
        query.BusinessYear = this.$store.state.businessYear
      }
      if (this.$store.state.documentActiv) {
        query.documentName = this.$store.state.documentActiv
      }
      if (this.$store.state.bookTypeSelected) {
        query.BookTypeID = this.$store.state.bookTypeSelected.value ? this.$store.state.bookTypeSelected.value : ''
      }
      query.searchName = null
      query.page =  0
      query.pageSize =  30
      query.searchItem =  null
      await this.$store.dispatch('setOnPage', query)
      this.searchName = ""
      this.page = 1
      this.totalPages = 0
      this.pageSize = 30
      this.mainQuery = query
    },
    async initAgain () {
      this.defaultQuery()
      this.defaultInit()
    }
  },
  computed: {
    ...mapGetters({
      myDocumentActivState: 'NeedDocumentActiv',
      myDocumentSide: 'NeedDocumentSide',
      myBookSelected: 'NeedMainLedgerBookTypeSelected'
    })
  },
  watch: {
    'myDocumentActivState' () {
      // Izbornik vodi na drugi ekran; ova vrsta je za njega, ne za ovaj popis
      // koji samo jos nije maknut s ekrana.
      if (this.$store.state.menuNavigating) { return }
      this.defaultInit()
      //this.initAgain(this.myDocumentActivState)
    },
    'myBookSelected' () {
      // Izbornik ocisti vrstu knjige prije preusmjeravanja (markMe salje null).
      // Ovaj popis se upravo mice s ekrana, njemu to vise nije bitno.
      if (this.$store.state.menuNavigating) { return }
      // Vrstu knjige je upravo postavio sam defaultInit (checkBooks); popis je
      // vec ucitan s njom, nema se sto ponovo dohvacati.
      if (this.samPostavioKnjigu) {
        this.samPostavioKnjigu = false
        return
      }
      this.defaultInit()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
